import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

import { fontFamily } from "../../../shared/styles";

export const dropdownButtonContainer = css`
    > div > .sds-base-button.ant-btn.default {
        ${fontFamily};
        flex-shrink: 0;

        font-weight: 500;
        line-height: 12px;
        color: ${Colors.Black.V100};

        box-shadow: 0 4px 8px rgba(0, 0, 0, 6%);
    }
`;
